// Square footage sorting functionality - uses first variant's gross_sf metafield
document.addEventListener('DOMContentLoaded', function() {
  console.log('Sqft sorting script loaded');

  // Parse sqft value - simple integer from variant metafield
  function parseSqft(sqft) {
    if (!sqft || sqft === '') {
      console.log('Empty sqft, returning -1');
      return -1;
    }
    
    const result = parseInt(sqft, 10);
    console.log('Parsed sqft:', sqft, '→', result);
    return result;
  }

  // Sort products by sqft
  function sortProductsBySqft(direction) {
    console.log('=== Starting sort by sqft:', direction, '===');
    
    // Try multiple possible selectors for the product grid
    const productGrid = document.querySelector('.product-grid') 
                     || document.querySelector('[data-product-grid]')
                     || document.querySelector('.product-list');
    
    console.log('Product grid element:', productGrid);
    
    if (!productGrid) {
      console.error('Product grid not found');
      return;
    }

    const products = Array.from(productGrid.querySelectorAll('product-block'));
    console.log('Found products:', products.length);
    
    if (products.length === 0) {
      console.error('No product-block elements found');
      return;
    }

    // Log current order before sorting
    console.log('Before sort:');
    products.forEach((p, i) => {
      console.log(i + ':', p.dataset.sqft);
    });

    products.sort((a, b) => {
      const aVal = parseSqft(a.dataset.sqft);
      const bVal = parseSqft(b.dataset.sqft);
      
      if (direction === 'high') {
        return bVal - aVal; // High to low
      } else {
        return aVal - bVal; // Low to high
      }
    });

    // Log order after sorting
    console.log('After sort:');
    products.forEach((p, i) => {
      console.log(i + ':', p.dataset.sqft);
    });

    // Re-append sorted products
    products.forEach(product => productGrid.appendChild(product));
    
    // Update dropdown display
    updateDropdownText(direction === 'high' ? 'Square Footage: High to Low' : 'Square Footage: Low to High');
    
    console.log('=== Sorting complete ===');
  }

  // Update the dropdown button text
  function updateDropdownText(text) {
    const dropdownButton = document.querySelector('.link-dropdown__button-text');
    if (dropdownButton) {
      dropdownButton.textContent = text;
      console.log('Updated dropdown text to:', text);
    }
    
    // Update active state
    document.querySelectorAll('.link-dropdown__link').forEach(link => {
      link.classList.remove('link-dropdown__link--active');
    });
  }

  // Event listeners - use event delegation on document
  document.addEventListener('click', function(evt) {
    const sqftLink = evt.target.closest('.js-sqft-sort');
    
    if (sqftLink) {
      console.log('>>> Sqft sort link clicked! <<<');
      console.log('Sort value:', sqftLink.dataset.sortValue);
      
      evt.preventDefault();
      evt.stopPropagation();
      
      const sortValue = sqftLink.dataset.sortValue;
      
      if (sortValue === 'sqft-high') {
        sortProductsBySqft('high');
      } else if (sortValue === 'sqft-low') {
        sortProductsBySqft('low');
      }
      
      // Mark as active
      sqftLink.classList.add('link-dropdown__link--active');
      
      // Close dropdown
      const dropdown = sqftLink.closest('link-dropdown');
      if (dropdown) {
        const button = dropdown.querySelector('.link-dropdown__button');
        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }
      }
      
      return false;
    }
  }, true);

  console.log('Sqft sorting event listeners attached');
});
